// Firebase configuration – reads from environment variables.
// Real values should be in your .env file (never committed).

import { initializeApp, getApps, type FirebaseApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};
// Initialize Firebase with error handling
// Check if Firebase is already initialized to prevent duplicate initialization errors
let firebaseApp: FirebaseApp;

try {
  const existingApps = getApps();
  if (existingApps.length > 0) {
    // Use existing app if already initialized
    firebaseApp = existingApps[0];
  } else {
    // Initialize new app
    firebaseApp = initializeApp(firebaseConfig);
  }
} catch (error) {
  console.error("🚨 CRITICAL: Failed to initialize Firebase:", error);
  // Re-throw to prevent app from continuing with broken Firebase
  throw new Error(
    `Firebase initialization failed: ${error instanceof Error ? error.message : "Unknown error"}. ` +
      "Please check your Firebase configuration and network connection.",
  );
}

export { firebaseApp };
